import { cB as o, c as r, cE as e } from "./ghl-ui.es384.js";
import { iconSwitchTransition as t } from "./ghl-ui.es1318.js";
const i = o("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [r(">", [e("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [r("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), r("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), e("placeholder", `
 display: flex;
 `), e("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [t({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]);
export {
  i as default
};
